import { Space as AntSpace } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { User } from 'api/models';
import { Avatar } from 'components/atoms/avatar';
import {
  Caption01,
  ProductiveHeading07,
  SingleLineEllipsis,
  Text01,
  Text02,
} from 'components/styles';
import { fullName } from 'utils/full-name';

const Card = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const Space = styled(AntSpace)`
  width: 80%;
`;

const Name = styled.div`
  ${ProductiveHeading07};
  ${Text01};
  ${SingleLineEllipsis};
`;
const Email = styled.div`
  ${Caption01};
  ${Text02};
  ${SingleLineEllipsis};
`;

export const UserCard: FC<{ user: User }> = ({ user }) => {
  const name = fullName(user);
  const { emailId } = user;

  return (
    <Card>
      <Space direction="vertical" size={4}>
        <Name title={name}>{name}</Name>
        <Email title={emailId}>{emailId}</Email>
      </Space>
      <Avatar src={user.photoUrl} name={name} />
    </Card>
  );
};
